import { createSelector } from 'reselect';
import { getLatestActivitySet } from './getLatestActivitySet';

const getWorkOrderId = createSelector([getLatestActivitySet], (activitySet) => {
  return activitySet.workOrderId;
});

export { getWorkOrderId };
